import React from 'react';
import { ImageWithPlaceholder } from '../../ui/ImageWithPlaceholder';
import { global } from '../../../utils';

export default function Card({data}) {
  const { imagen, titulo, segmento, fecha, municipio, etiquetas} = data;

  function formatDate(date) {
    const [yy,mm,dd] = date.split('-');
    return `${dd}/${mm}/${yy.slice(2)}`;
  }

  return (
    <div className='card-container'>
      <div className='card'>
        <div className="card__head">
          <ImageWithPlaceholder 
            src={`${global.managerURL}/archivos/eventos/${imagen}`}
            alt={titulo}
          />
        </div>
        <div className="card__body">
          <h5>{titulo}</h5>
          <ul className='data'>
            <li className='seg'><i></i> <span><strong>{segmento}</strong></span></li>
            <li className='fec'><i></i> <span><strong>{formatDate(fecha)}</strong></span></li>
            <li className='ciu'><i></i> <span><strong>{municipio}</strong></span></li>
          </ul>
          <div className="tags">
            {etiquetas.split(',').map(label => <li key={label}>{label}</li>)}
          </div>
        </div>
      </div>
    </div>
  );
}